import { useSequenceState } from './motion.jsx';
import { revealState } from '../../hooks/useReveal.js';
import styles from './Eyebrow.module.css';

/**
 * The small tracked-out label above a heading.
 *
 * Inside a <Sequence> it opts into the drawn-dash treatment automatically.
 * Outside one there is nothing to time it against, so it simply renders.
 */
export function Eyebrow({
  as: Tag = 'span',
  onDark = false,
  centered = false,
  animated = true,
  className = '',
  children,
  ...rest
}) {
  const { inSequence, shown } = useSequenceState();
  const classes = [
    styles.eyebrow,
    onDark ? styles.onDark : '',
    centered ? styles.centered : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag
      className={classes}
      {...(animated && inSequence ? { 'data-seq-eyebrow': revealState(shown) } : null)}
      {...rest}
    >
      {children}
    </Tag>
  );
}
